<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('scope.text_284')"
    icon="menu-tenant"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :tabs="detailTabs"
    :loaded="loaded"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions
        :options="singleActions"
        :row="detailData"
        button-type="link"
        button-size="small" />
    </template>
    <component
      :is="params.windowData.currentTab"
      :data="detailData"
      :serverColumns="columns"
      :res-id="data.id"
      :getParams="getParams"
      :on-manager="onManager"
      @refresh="refresh"
      @single-refresh="singleRefresh"
      @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import * as R from 'ramda'
import SingleActionsMixin from '../mixins/singleActions'
import ColumnsMixin from '../mixins/columns'
import ConsumerInfo from '../../../sections/ConsumerInfoSidepage'
import CloudAccountManagerDetail from './Detail'
import DiscountInfo from './DiscountInfo'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'

export default {
  name: 'CloudAccountManagerSidePage',
  components: {
    Actions,
    CloudAccountManagerDetail,
    ConsumerInfo,
    DiscountInfo,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin, SingleActionsMixin],
  data () {
    return {}
  },
  computed: {
    getParams () {
      return null
    },
    detailTabs () {
      let tabs = [
        { label: this.$t('scope.text_433'), key: 'cloud-account-manager-detail' },
        { label: this.$t('scope.text_435'), key: 'event-drawer' },
      ]
      if (!R.isEmpty(this.detailData) && this.detailData.cloudaccount_id) {
        tabs = [
          { label: this.$t('scope.text_433'), key: 'cloud-account-manager-detail' },
          { label: this.$t('scope.text_541'), key: 'consumer-info' },
          { label: this.$t('scope.text_542'), key: 'discount-info' },
          { label: this.$t('scope.text_435'), key: 'event-drawer' },
        ]
      }
      return tabs
    },
  },
}
</script>
